import { AnalyticsData } from "../../types/AnalyticsData.interface";

export const getAnalyticsData = <T extends AnalyticsData["analyticsDataType"]>(
  type: T,
  data: (AnalyticsData | undefined)[],
): Extract<AnalyticsData, { analyticsDataType: T }> | undefined => {
  return data?.find((d) => d?.analyticsDataType === type) as
    | Extract<AnalyticsData, { analyticsDataType: T }>
    | undefined;
};
